export type MenuGroup =
  | "home"
  | "customerData"
  | "connect"
  | "developer"
  | "organization"
  | "lab";

/**
 * The platform's two products plus the pages that belong to neither:
 * Customer Data Hub holds the customer data, Admin Center the org-wide
 * settings (product access, billing, contracts) shared by every product.
 */
export type MenuArea = "platform" | "dataHub" | "adminCenter";

/** The order groups appear in the side menu. */
export const MENU_GROUP_ORDER: ReadonlyArray<MenuGroup> = [
  "home",
  "customerData",
  "connect",
  "developer",
  "lab",
  "organization",
];

export const MENU_GROUP_AREA: Record<MenuGroup, MenuArea> = {
  home: "platform",
  customerData: "dataHub",
  connect: "dataHub",
  developer: "dataHub",
  lab: "platform",
  organization: "adminCenter",
};

/**
 * Splits visible menu items into their groups, in `MENU_GROUP_ORDER`, keeping
 * each group's item order. Groups with no visible item are left out, so an
 * organization without, say, Vibe Lab never sees an empty "Labs" heading.
 */
export const groupMenuItems = <TItem extends { group: MenuGroup }>(
  items: ReadonlyArray<TItem>,
): Array<{ group: MenuGroup; area: MenuArea; items: Array<TItem> }> =>
  MENU_GROUP_ORDER.map((group) => ({
    group,
    area: MENU_GROUP_AREA[group],
    items: items.filter((item) => item.group === group),
  })).filter((section) => section.items.length > 0);
